import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Alert = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10 10.556L10 6.2782" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M10 13.306V13.2504" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M10.0001 17.2226C13.9888 17.2226 17.2223 13.9891 17.2223 10.0004C17.2223 6.0117 13.9888 2.7782 10.0001 2.7782C6.01133 2.7782 2.77783 6.0117 2.77783 10.0004C2.77783 13.9891 6.01133 17.2226 10.0001 17.2226Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Alert;